import React from 'react';
import { FaExclamationTriangle, FaListOl, FaTrashAlt, FaDatabase, FaEnvelope } from 'react-icons/fa';
import './AccountDeletionSection.css';

function AccountDeletionSection() {
  return (
    <section className="account-deletion-section">
      <div className="deletion-container">
        <h1>
          <span className="text-gradient">Account &amp; Data Deletion</span>
        </h1>
        <p className="deletion-subtitle">
          We're sorry to see you go. Please review the information below before proceeding with your request.
        </p>

        <div className="deletion-content">
          {/* Warning Section */}
          <div className="deletion-warning">
            <FaExclamationTriangle className="warning-icon" />
            <div className="warning-text">
              <h3>Important Notice</h3>
              <p>
                Account deletion is permanent and irreversible. All your data, transaction history, and wallet balance will be permanently removed from our systems.
              </p>
            </div>
          </div>

          {/* Steps Section */}
          <div className="deletion-steps">
            <h2>
              <FaListOl className="steps-icon" />
              How to Request Account Deletion
            </h2>
            <ol className="steps-list">
              <li className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h4>Send an Email</h4>
                  <p>
                    Email us at <strong>admin@rskonlineservices.com</strong> from your registered email address with the subject "Account Deletion Request" or "Data Deletion Request".
                  </p>
                </div>
              </li>
              <li className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h4>Provide Verification Details</h4>
                  <p>
                    Include your registered mobile number or email address in the message body to help us verify your identity.
                  </p>
                </div>
              </li>
              <li className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h4>Wait for Confirmation</h4>
                  <p>
                    Our team will verify your identity and process your request within 7 working days. You'll receive a confirmation email once the deletion is complete.
                  </p>
                </div>
              </li>
            </ol>
          </div>

          {/* Data Details */}
          <div className="deletion-details">
            <div className="detail-card">
              <h3>
                <FaTrashAlt className="detail-icon" />
                Data Deleted
              </h3>
              <ul>
                <li>Personal information (name, email, phone)</li>
                <li>Transaction history</li>
                <li>Wallet balance and payment methods</li>
                <li>App preferences and settings</li>
                <li>Communication history</li>
              </ul>
            </div>

            <div className="detail-card">
              <h3>
                <FaDatabase className="detail-icon" />
                Data Retained
              </h3>
              <ul>
                <li>Transaction records (up to 180 days for regulatory compliance)</li>
                <li>Fraud prevention and legal records</li>
                <li>Anonymized analytics data</li>
              </ul>
            </div>
          </div>

          {/* Contact Section */}
          <div className="contact-section">
            <h3>Need Help?</h3>
            <p>
              If you have any questions or concerns about the account deletion process, feel free to reach out to our support team.
            </p>
            <a href="mailto:admin@rskonlineservices.com" className="email-link">
              <FaEnvelope className="email-icon" />
              admin@rskonlineservices.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AccountDeletionSection;
